import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
    "https://piwlisxgmqaedclahojw.supabase.co"
    , 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBpd2xpc3hnbXFhZWRjbGFob2p3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NDY3NzA3MjksImV4cCI6MTk2MjM0NjcyOX0.Qm5dO2bV0_MoqQaGB33Q-oux47TCs14ioMGfiONmUSw')


